<template>
    <div>
        <div class=" container-fluid   ">
        <div class="llp-container-section  heightcontainer ">
          <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
       <!-- <div class="container-fluid">-->
            <div id="deals" class=" container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px" >
            <div>
                <nav class="navbar navbar-expand-lg bg-info text-white">
                    <span><b>Manage Profile</b></span>
                </nav>
                <div v-if="error">
                    <p align="center" class="alert-danger">{{error}}</p>
                </div>
                <div v-if="saved">
                    <p align="center" class="confirm-message">Password updated successfully</p>
                </div>

                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col d-flex justify-content-end align-items-center">
                        <label name="current Password" class="col-form-label col-form-label-sm required">Current Password</label>
                    </div>
                    <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input type="password" autofocus data-vv-as="Current Password" class="form-control input-sm" name="cpwd" v-validate="'required'" v-model.trim="profile.currentpwd" placeholder="Enter your password" />
                        <div v-if="errors.has('cpwd')" class="alert-danger">{{ errors.first('cpwd') }}</div>
                    </div>
                </div>
                <br />
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col d-flex justify-content-end align-items-center">
                        <label name="new Password" class="col-form-label col-form-label-sm required">New Password </label>
                    </div>
                    <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input type="password" name="npwd" data-vv-as="New Password" class="form-control input-sm" v-validate="'required'" v-model.trim="profile.newpwd" ref="newpassword" placeholder="Enter your password" />
                        <div v-if="errors.has('npwd')" class="alert-danger">{{ errors.first('npwd') }}</div>
                    </div>
                </div>
                <br />
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col d-flex justify-content-end align-items-center">
                        <label name="Reenter Password" class="col-form-label col-form-label-sm required">ReEnter Password </label>
                    </div>
                    <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input type="password" name="rpwd" data-vv-as="Password" class="form-control input-sm" v-validate="'required|confirmed:newpassword'" v-model.trim="profile.newrentpwd" placeholder="Confirm your password" />
                        <div v-if="errors.has('rpwd')" class="alert-danger">{{ errors.first('rpwd') }}</div>
                    </div>
                </div>
                <br />
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col-lg-3 col-md-3 col-sm-3 d-flex justify-content-end align-items-center">
                        <center>
                            <button type="submit" class="btn btn-secondary" @click.prevent="updateProfile">Update</button>
                        </center>
                    </div>
                </div>
            </div>
            <!-- END of Container TAG -->
        </div>
        <!-- END of PAGE Container TAG -->
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
        </div>
        </div>
    </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import employeeSvc from '../js/http-employee.js'

export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'manageEmployee',
  data () {
    return {
      profile: this.initializedata(), // intialize  entry fields
      error: '',
      saved: false
    }
  },
  methods: {
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#deals').css('margin-top', txt + txt1 + 5)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    initializedata () {
      return {
        currentpwd: '',
        newpwd: '',
        newrentpwd: ''
      }
    },
    updateProfile () {
      this.saved = false
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          let searchUser = {
            emailId: this.$session.get('user_id'),
            passWord: this.profile.currentpwd,
            newPassWord: this.profile.newpwd
          }
          // console.log("Update profile request: "+JSON.stringify(searchUser));
          // make service call
          employeeSvc
            .put('/userlogin/', searchUser)
            .then((response) => {
              // console.log("Update profile Response: "+JSON.stringify(response));
              var userobject = response.data
              //  if(response.status == "200"){
              if (userobject.apiStatusMessage == null) {
                // Success?
                this.saved = true
                this.profile = this.initializedata()
                this.errors.clear()
                this.$validator.reset()
              } else {
                this.saved = false
                this.error = userobject.apiStatusMessage
              }
              // }
            })
            .catch(function (e) {
              console.log('Update password Failure' + e)
              this.error = 'Update Password Failed'
              this.saved = false
            })
        } // end if
      })
    }
  },
  mounted () {
    this.myFunction()
    this.menuheight()
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>
<style scoped></style>
